import React, {useEffect, useRef} from 'react'
import {useTranslation} from 'react-i18next'
import {useAccountStyle} from '@containers/accountStyle/hooks/useAccountStyle'
import {useUpdateUserStyleMutation} from '@containers/accountStyle/queryHooks/useUserStyleQuery'
import MenuColorPicker from '@containers/accountStyle/picker/MenuColorPicker'

const CUSTOM_SAVE_DELAY_MS = 400

const AccountColorPicker = () => {
	const {t} = useTranslation()
	const {userMenuColor} = useAccountStyle()
	const {mutate} = useUpdateUserStyleMutation()
	const saveTimer = useRef<ReturnType<typeof setTimeout>>()

	useEffect(() => () => clearTimeout(saveTimer.current), [])

	const onCustomChange = (color: string) => {
		clearTimeout(saveTimer.current)
		saveTimer.current = setTimeout(() => mutate(color), CUSTOM_SAVE_DELAY_MS)
	}

	return (
		<MenuColorPicker
			value={userMenuColor}
			onSelect={(color) => mutate(color)}
			onCustomChange={onCustomChange}
			tooltip={t('base.menuColor')}
			resetLabel={t('base.menuColorAccount')}
		/>
	)
}

export default AccountColorPicker
